import React from "react";

const NoteFound = () => {
  return <div>404</div>;
};

export default NoteFound;
